import { getAppConfig } from "../services/config";

const config = getAppConfig();

export const isAuthedUserAdmin = (auth: any): boolean => {
  const userGroups = auth.user?.profile?.groups as string[];
  const adminGroups = config.adminGroups;
  return (
    userGroups &&
    adminGroups &&
    userGroups.some((item) => adminGroups.includes(item))
  );
};

export const isOtpEnabledForAuthedUser = (auth: any): boolean => {
  return (auth.user?.profile?.otp_enabled as boolean) ?? false;
};

export const isAuthedUserManager = (auth: any): boolean => {
  return (auth.user?.profile?.is_manager as boolean) ?? false;
};
